<template>
  <div>
    <categories-filter @filterByTypes="dispatchMusics" />
    <filter-musics
      :themes="themes"
      :musicsLength="count"
      @updateMusicsByFilter="dispatchMusics"
      @filterByText="dispatchMusics"
      @getRepertoriesByIntesities="dispatchMusics"
    />
    <!-- <my-repertory-items
      :selectedElements="selected"
      @deselected="removeItemToPlaylist"
      @clearSelected="clearSelected"
      @compareArrays="dispatchMusics"
      @setId="setIdRepertory"
    /> -->
    <template v-if="loading">
      <div class="d-flex justify-content-center p-5">
        <b-spinner variant="success" style="width: 3rem; height: 3rem;" />
      </div>
    </template>
    <div class="container" v-else-if="music_to_select.length">
      <div class="row">
        <div
          class="col-lg-4 d-flex w-100"
          v-for="music in music_to_select"
          :key="music.id"
        >
          <music-repertory
            :music="music"
            @selected="addItemToPlaylist(music)"
            :idRepertory="idRepertory"
          />
        </div>
      </div>
    </div>
    <div v-else class="container py-5">
      <em>Nenhuma musica cadastrada ainda :(</em>
    </div>
    <pagination-see-more
      @dispatch="dispatchMusics"
      :isLoading="loadingNewMusics"
      :count="count"
      :initLimit="limit"
    />
  </div>
</template>

<script>
import CategoriesFilter from "@/components/repertory/CategoriesFilter.vue";
import MusicRepertory from "@/components/repertory/MusicRepertory.vue";
// import MyRepertoryItems from "@/components/repertory/MyRepertoryItems.vue";
import FilterMusics from "@/components/repertory/FilterMusics.vue";
import { mapState } from "vuex";
export default {
  components: {
    CategoriesFilter,
    MusicRepertory,
    // MyRepertoryItems,
    FilterMusics
  },
  data() {
    return {
      selected: [],
      loading: true,
      idRepertory: false,
      limit: 15,
      loadingNewMusics: true,
      idsThemesToFilter: "",
      idsMusicsToExclude: "",
      typesToFilter: "",
      textToFilter: "",
      idsIntensities: "",
      letters: "",
      order_by: ""
    };
  },
  computed: {
    ...mapState("repertories", ["musics", "count", "themes"]),
    music_to_select() {
      return this.musics.filter(
        ({ id }) => !this.selected.find(m => m.id == id)
      );
    }
  },
  methods: {
    addItemToPlaylist(music) {
      this.selected.push(music);
    },
    removeItemToPlaylist(music) {
      const index = this.selected.indexOf(music);
      this.selected.splice(index, 1);
    },
    clearSelected(items) {
      this.selected = [];
    },
    setIdRepertory(payload) {
      this.idRepertory = Boolean(payload.id);
    },
    dispatchMusics(payload) {
      this.loading = true;
      this.loadingNewMusics = true;
      if (payload?.idsThemes) {
        this.idsThemesToFilter = payload.idsThemes;
      }
      if (payload?.idsIntensities) {
        this.idsIntensities = payload.idsIntensities;
      }
      if (payload?.musics?.length > 0) {
        this.selected = payload.musics;
        const idsSelecteds = this.selected.map(music => music.id);
        this.idsMusicsToExclude = idsSelecteds.join();
      } else if (payload?.musics) {
        this.selected = [];
        this.idsMusicsToExclude = "";
      }
      if (payload?.types) {
        if (payload.types.join() == 1) {
          this.typesToFilter = "";
        } else {
          this.typesToFilter = payload.types.join() + ",";
        }
      }
      if (payload?.letters?.length) {
        this.letters = payload.letters.join();
        this.limit = 15;
      } else if (payload?.letters) {
        this.letters = "";
        this.limit = 15;
      }
      if (payload?.text) {
        this.textToFilter = payload.text;
      } else {
        this.textToFilter = "";
      }
      if (payload?.limit) {
        this.limit = payload.limit;
        this.loading = false;
      }
      if (payload?.order_by) {
        this.order_by = payload.order_by;
      } else {
        this.order_by = "alpha";
      }

      this.$store
        .dispatch("repertories/getMusics", {
          limit: this.limit,
          idsThemes: this.idsThemesToFilter,
          idsMusics: this.idsMusicsToExclude,
          typesToFilter: this.typesToFilter,
          textToFilter: this.textToFilter,
          idsIntensities: this.idsIntensities,
          letters: this.letters,
          order_by: this.order_by
        })
        .then()
        .finally(() => {
          this.loading = false;
          this.loadingNewMusics = false;
        });
    }
  },
  mounted() {
    this.dispatchMusics();
    this.$store
      .dispatch("repertories/getThemesToFilter")
      .then()
      .finally();
  }
};
</script>

<style lang="scss" scoped></style>
